import React, { useEffect, useState } from 'react'
import { Formik, Form as Formiker, Field as Fieldmik } from 'formik';
// import UploadFile from '../../components/UiComponents/fileUpload';
// import MyReasons from '../../components/apiInputs/myReasons';
import moment from 'moment'
import * as yup from 'yup';
// import CreateCommonAxios from '../../components/axiosComponent/commanCreateAxios';
import { Modal, Form as FormUi, Divider, Grid, Icon, Button, Table, Container, List } from 'semantic-ui-react';
import { MyDropdown, MyNormalInput, MyTextArea } from '../../dynamicComponent/myInputs';
import UploadFile from '../../common/uploadFile';
import UploadPODFile from '../../common/uploadPODFile';
import ReadAxios from '../../axiosComponent/read';
import CreatAxios from '../../axiosComponent/create';
import cogoToast from 'cogo-toast';
import Axios from 'axios';
const AddPod = (props) => {
    // console.log('>>>', props.auth.userKey)
    let handleEnter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
        }
    }
    const [totalQuantities, settotalQuantities] = useState(0)
    const [reasonOptions, setReasonOptions] = useState([])
    useEffect(() => {
        let quantities = [];
        if (props?.deliveryDetails && props.deliveryDetails.length > 0) {
            if (props?.deliveryDetails?.[0]?.products && props.deliveryDetails[0].products.length > 0) {
                props.deliveryDetails[0].products.map((o, i) => {
                    quantities.push(o.quantity)
                })
            }
        }
        settotalQuantities(quantities.reduce((r, c) => r + parseFloat(c), 0))
        ReadAxios({ url: `shortageDamageReasonMaster/` })
            .then((result) => {
                // setcontents(result)
                if (result.data.status === 200) {
                    setReasonOptions(result.data.resultSet)
                }
                // setloading(false)
                // console.log('>>>', result)
            })

    }, [props.deliveryDetails, props.orders])
    let validateSchema = yup.object().shape({
        deliveryImage: yup.mixed().required('Required').test("fileSize", "The file is too large", (value) => {
            return value && value.fileList[0].size <= 5000000
        }),
        // deliveryBackImage: yup.mixed().notRequired().test("fileSize", "The file is too large", (value) => {
        //     return value && value.fileList[0].size <= 5000000
        // }),
        shortageQuantity: yup.number().optional().nullable(),
        shortageReason: yup.string().when('shortageQuantity', {
            is: (value) => value,
            then: yup.string().required('Required'), otherwise: yup.string().optional()
        }),
        excessQuantity: yup.number().optional().nullable(),
        excessReason: yup.string().when('excessQuantity', {
            is: (value) => value,
            then: yup.string().required('Required'), otherwise: yup.string().optional()
        }),
        damageQuantity: yup.number().optional().nullable(),
        damageReason: yup.string().when('damageQuantity', {
            is: (value) => value,
            then: yup.string().required('Required'), otherwise: yup.string().optional()
        }),
        driverName: yup.string().optional().nullable(),
        recipientName: yup.string().required('Required'),

    })
    let options = []
    if (reasonOptions.length > 0) {
        reasonOptions.map((ob, idx) => {
            let temp = {}
            temp.key = ob.reasonId
            temp.text = ob.reasonDescription
            temp.value = ob.reasonId
            return options[idx] = temp
        })
    }
    return (
        <Modal open={props.open} onClose={props.onClose}>
            <Modal.Header>ADD POD</Modal.Header>
            <Table className="w3-small">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan="4" className="text-left w3-white w3-text-blue">Invoice Details</Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell className="text-left">Invoice Number</Table.HeaderCell>
                        <Table.HeaderCell className="text-left">Tracking Number</Table.HeaderCell>
                        <Table.HeaderCell className="text-left">Invoice Date</Table.HeaderCell>
                        <Table.HeaderCell className="text-left">Invoice Quantity</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.deliveryDetails && props.deliveryDetails.length > 0 ?
                        props.deliveryDetails.map((object, index) => (
                            <>
                                {object?.invoices && object.invoices.length > 0 ?
                                    object.invoices.map((obj, i) => {
                                        return (<Table.Row>
                                            <Table.Cell>{obj.invoice_no}</Table.Cell>
                                            <Table.Cell>{obj.tracking_number}</Table.Cell>
                                            <Table.Cell>{moment(obj.invoice_date).format('DD-MM-YYYY')}</Table.Cell>
                                            <Table.Cell>{obj.invoice_quantity}</Table.Cell>
                                        </Table.Row>
                                        )
                                    })
                                    : ''}
                            </>
                        )) : ''}
                </Table.Body>
            </Table>
            <Formik
                initialValues={{
                    orderNo: props.orders.order_no,
                    deliveryImage: '',
                    deliveryNo: props.delivery ? props.delivery.delivery_no : '',
                    deliveryBackImage: '',
                    recipientName: '',
                    driverName: props.orders.driver_name,
                    quantities: totalQuantities,
                    customerInvoice: '',
                    shipmentImage: '',
                    recipientImage: '',
                    dataLogger: '',
                    vendorInvoice: '',
                    signatureImage: '',
                    deliveryAgentSelfie: '',
                    shortageQuantity: '',
                    excessQuantity: '',
                    damageQuantity: '',
                    shortageReason: '',
                    damageReason: '',
                    excessReason: '',
                    elixiaRefNumber: '',
                    userKey: props.auth.userKey,
                    deliveryTimeStamp: moment().format('YYYY-MM-DD HH:mm:ss'),
                    customerNumber: localStorage.getItem("customerNumber"),
                    userId: localStorage.getItem("userId"),
                    customer_no: +localStorage.getItem("customerNumber"),
                    customerNo: +localStorage.getItem("customerNumber"),
                    user_id: +localStorage.getItem("userId"),
                }}
                validationSchema={validateSchema}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true)
                    const data = {
                        deliveryNo: values.deliveryNo,
                        orderNo: values.orderNo,
                        userKey: values.userKey,
                        userId: localStorage.getItem("userId"),
                        customerNumber: localStorage.getItem("customerNumber"),
                        recipientName: values.recipientName,
                        deliveryTimeStamp: values.deliveryTimeStamp,
                        customerRefNumber: "",
                        driverName: values.driverName,
                        amount: "",
                        totalQuantity: values.quantities,
                        shortageQuantity: values.shortageQuantity,
                        shortageReason: values.shortageReason,
                        damageQuantity: values.damageQuantity,
                        damageReason: values.damageReason,
                        excessQuantity: values.excessQuantity,
                        excessReason: values.excessReason,
                        deliveryNotes: values.note,
                    };

                    // console.log(combineParams)
                    // return;
                    setSubmitting(true)
                    Axios.put(`${process.env.REACT_APP_BASE_COMMON}/pod/meta_data/delivery_primary`, data, {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            "Access-Control-Allow-Headers": "*",
                            crossorigin: true,
                            Authorization: `${localStorage.getItem("isloggedIn")}`,
                        }
                    }).then((response) => {

                        cogoToast.success(response.data.message)
                        window.location.reload()
                    }).catch((err) => {
                        setSubmitting(false)
                        // cogoToast.error(err.response.data.message)
                    })

                }}
            >
                {({ values, isSubmitting, touched, errors, handleSubmit }) => {

                    return (
                        <>
                            <Modal.Content>
                                <Modal.Description>
                                    <div className="ui form tiny">
                                        <Divider horizontal>
                                            <label className="p-bold-600 w3-text-blue">Basic Details</label>
                                        </Divider>
                                        <Grid columns="3" padded>
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <label>Delivery Number *</label> <br />
                                                    <Fieldmik component={MyNormalInput} readOnly name="deliveryNo" />
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <label>Driver Name</label> <br />
                                                    <Fieldmik component={MyNormalInput} name="driverName" />
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <label>Recipient Name *</label> <br />
                                                    <Fieldmik component={MyNormalInput} name="recipientName" />
                                                    {touched.recipientName && errors.recipientName ? <small className="form-text text-danger">{errors.recipientName} </small> : ''}
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                        <Divider horizontal>
                                            <label className="p-bold-600 w3-text-blue">PoD</label>
                                        </Divider>
                                        <Grid columns="2" padded>
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <label>LR Front *</label> <br />
                                                    <Fieldmik name="deliveryImage" style={{ width: '23%' }} values={values} buttonName={values.deliveryImage ? "File Selected" : "Choose File"} className="w3-button w3-round w3-small w3-border w3-hover-blue" typer={[".pdf", ".jpeg", ".jpg", ".png"]} component={UploadPODFile} />
                                                    {touched.deliveryImage && errors.deliveryImage ? <small className="form-text text-danger">{errors.deliveryImage} </small> : ''}
                                                    <List horizontal color size={'mini'}>
                                                        <List.Item as='small'>Note: PDF files less than 5mb allowed.</List.Item>
                                                    </List>
                                                    {/* <small className="form-text text-muted w3-text-red font-weight-bold">Note: PDF files less than 5mb allowed.</small> */}
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <label>LR Back </label> <br />
                                                    <Fieldmik name="deliveryBackImage" style={{ width: '23%' }} values={values} buttonName={values.deliveryBackImage ? "File Selected" : "Choose File"} className="w3-button w3-round w3-small w3-border w3-hover-blue" typer={[".pdf", ".jpeg", ".jpg", ".png"]} component={UploadPODFile} />
                                                    {touched.deliveryBackImage && errors.deliveryBackImage ? <small className="form-text text-danger">{errors.deliveryBackImage} </small> : ''}
                                                    <List horizontal color size={'mini'}>
                                                        <List.Item as='small'>Note: PDF files less than 5mb allowed.</List.Item>
                                                    </List>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                        <Divider horizontal>
                                            <label className="p-bold-600 w3-text-blue">Invoices & Images</label>
                                        </Divider>
                                        <Grid columns="4" padded>
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <label>Goods Invoice</label> <br />
                                                    <Fieldmik name="customerInvoice" multiple={true} buttonName={values.customerInvoice ? "File Selected" : "Choose File"} className="w3-button w3-round w3-small w3-border  w3-hover-blue" typer={['.pdf']} values={values} component={UploadPODFile} />
                                                    {touched.customerInvoice && errors.customerInvoice ? <small className="form-text text-danger">{errors.customerInvoice} </small> : ''}
                                                    <List horizontal color size={'mini'}>
                                                        <List.Item as='small'>Note: PDF files less than 5mb allowed.</List.Item>
                                                    </List>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <label>Vendor Invoice</label> <br />
                                                    <Fieldmik name="vendorInvoice" buttonName={values.vendorInvoice ? "File Selected" : "Choose File"} className="w3-button w3-round w3-small w3-border  w3-hover-blue" typer={['.pdf']} component={UploadPODFile} values={values} />
                                                    {touched.vendorInvoice && errors.vendorInvoice ? <small className="form-text text-danger">{errors.vendorInvoice} </small> : ''}
                                                    <List horizontal color size={'mini'}>
                                                        <List.Item as='small'>Note: PDF files less than 5mb allowed.</List.Item>
                                                    </List>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <label>Data Logger</label> <br />
                                                    <Fieldmik name="dataLogger" buttonName={values.dataLogger ? "File Selected" : "Choose File"} className="w3-button w3-round w3-small w3-border  w3-hover-blue" typer={['.pdf']} component={UploadPODFile} values={values} />
                                                    {touched.dataLogger && errors.dataLogger ? <small className="form-text text-danger">{errors.dataLogger} </small> : ''}
                                                    <List horizontal color size={'mini'}>
                                                        <List.Item as='small'>Note: PDF files less than 5mb allowed.</List.Item>
                                                    </List>
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <label>Shipment Image</label> <br />
                                                    <Fieldmik name="shipmentImage" buttonName={values.shipmentImage ? "File Selected" : "Choose File"} className="w3-button w3-round w3-small w3-border  w3-hover-blue" typer={['.png', '.jpg', '.jpeg']} component={UploadPODFile} values={values} />
                                                    {touched.shipmentImage && errors.shipmentImage ? <small className="form-text text-danger">{errors.shipmentImage} </small> : ''}
                                                    <List horizontal color size={'mini'}>
                                                        <List.Item as='small'>Note: Image files less than 5mb allowed.</List.Item>
                                                    </List>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <label>Recipient Image</label> <br />
                                                    <Fieldmik name="recipientImage" buttonName={values.recipientImage ? "File Selected" : "Choose File"} className="w3-button w3-round w3-small w3-border  w3-hover-blue" typer={['.png', '.jpg', '.jpeg']} component={UploadPODFile} values={values} />
                                                    {touched.recipientImage && errors.recipientImage ? <small className="form-text text-danger">{errors.recipientImage} </small> : ''}
                                                    <List horizontal color size={'mini'}>
                                                        <List.Item as='small'>Note: Image files less than 5mb allowed.</List.Item>
                                                    </List>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <label>Signature</label> <br />
                                                    <Fieldmik name="signatureImage" buttonName={values.signatureImage ? "File Selected" : "Choose File"} className="w3-button w3-round w3-small w3-border  w3-hover-blue" typer={['.png', '.jpg', '.jpeg']} component={UploadPODFile} values={values} />
                                                    {touched.signatureImage && errors.signatureImage ? <small className="form-text text-danger">{errors.signatureImage} </small> : ''}
                                                    <List horizontal color size={'mini'}>
                                                        <List.Item as='small'>Note: Image files less than 5mb allowed.</List.Item>
                                                    </List>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <label>Delivery Agent Image</label> <br />
                                                    <Fieldmik name="deliveryAgentSelfie" buttonName={values.deliveryAgentSelfie ? "File Selected" : "Choose File"} className="w3-button w3-round w3-small w3-border w3-hover-blue" typer={['.png', '.jpg', '.jpeg']} component={UploadPODFile} values={values} />
                                                    {touched.deliveryAgentSelfie && errors.deliveryAgentSelfie ? <small className="form-text text-danger">{errors.deliveryAgentSelfie} </small> : ''}
                                                    <List horizontal color size={'mini'}>
                                                        <List.Item as='small'>Note: Image files less than 5mb allowed.</List.Item>
                                                    </List>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                        <Divider horizontal>
                                            <label className="p-bold-600 w3-text-blue">Other Details</label>
                                        </Divider>
                                        <Grid columns="2" padded>
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <label>Shortage Quantity</label> <br />
                                                    <Fieldmik component={MyNormalInput} min="0" name="shortageQuantity" type="number" placeholder="Shortage Quantity" />
                                                    {touched.shortageQuantity && errors.shortageQuantity ? <small className="form-text text-danger">{errors.shortageQuantity} </small> : ''}
                                                </Grid.Column>
                                                <Grid.Column>
                                                    {/* {console.log('>>>', values.shortageReason)} */}
                                                    <label>Reason</label> <br />
                                                    <Fieldmik name="shortageReason" options={options} component={MyDropdown} reasonsName="shortage" />
                                                    {touched.shortageReason && errors.shortageReason ? <small className="form-text text-danger">{errors.shortageReason} </small> : ''}
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <label>Damage Quantity</label> <br />
                                                    <Fieldmik component={MyNormalInput} min="0" name="damageQuantity" type="number" placeholder="Damage Quantity" />
                                                    {touched.damageQuantity && errors.damageQuantity ? <small className="form-text text-danger">{errors.damageQuantity} </small> : ''}
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <label>Reason</label> <br />
                                                    <Fieldmik options={options} component={MyDropdown} name="damageReason" reasonsName="damage" />
                                                    {touched.damageReason && errors.damageReason ? <small className="form-text text-danger">{errors.damageReason} </small> : ''}
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <label>Excess Quantity</label> <br />
                                                    <Fieldmik component={MyNormalInput} min="0" name="excessQuantity" type="number" placeholder="Excess Quantity" />
                                                    {touched.excessQuantity && errors.excessQuantity ? <small className="form-text text-danger">{errors.excessQuantity} </small> : ''}
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <label>Reason</label> <br />
                                                    <Fieldmik options={options} component={MyDropdown} name="excessReason" reasonsName="excess" />
                                                    {touched.excessReason && errors.excessReason ? <small className="form-text text-danger">{errors.excessReason} </small> : ''}
                                                </Grid.Column>
                                                <Grid.Column columns="4">
                                                    <label>Notes</label> <br />
                                                    <Fieldmik component={MyTextArea} name="note" />
                                                    {touched.note && errors.note ? <small className="form-text text-danger">{errors.note} </small> : ''}
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                    </div>
                                </Modal.Description>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button onClick={props.onClose} size="mini" color='grey'>
                                    <Icon name='remove' /> Close
                                </Button>
                                <Button type="submit" loading={isSubmitting ? true : false} onClick={handleSubmit} disabled={isSubmitting} size="mini" color='blue'>
                                    <Icon name='checkmark' /> Save
                                </Button>
                            </Modal.Actions>
                        </>
                    )
                }}
            </Formik>

        </Modal>
    )
}

export default AddPod
